import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const Content = styled(Row)`
  gap: 85px;
  justify-content: space-between;
  width: 100%;
`;

type UpdateButtonProps = {
  borderColor: string;
};

export const UpdateButton = styled.div<UpdateButtonProps>`
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${({ borderColor }) => borderColor};
  cursor: pointer;
  display: flex;
  flex-basis: 120px;
  height: 36px;
  justify-content: center;
`;

export const TextContainer = styled.div`
  flex: 1;
`;
